import { Widget } from '../core/Widget.js';
import { resolveOwner, resolveFilterOwnerAdapter } from './FilterOwner.js';

// search-core/SortWidget.ts
/**
 * Виджет сортировки колонок (порт старого кода jQuery).
 * Управляет переключением направлений сортировки, состоянием классов
 * и ARIA-атрибутами, а также уведомляет владельца о применении сортировки.
 */
class SortWidget extends Widget {
    /** Инициализация виджета */
    _create(op) {
        this._owner = resolveOwner(this.element, op, 'SortWidget');
        this._ownerAdapter = resolveFilterOwnerAdapter(this._owner, op.ownerAdapter, "SortWidget");
        this._toggleSelector = op.toggleSelector ?? '._tsc';
        this._bind();
        this._hydrateFromDom();
    }
    /** Подписка на клики по кнопкам сортировки */
    _bind() {
        this._onClick = (e) => {
            const t = e.target;
            if (!t)
                return;
            const btn = t.closest(this._toggleSelector);
            if (!btn)
                return;
            this._cycle(btn);
        };
        this.element.addEventListener('click', this._onClick);
    }
    /** Цикл смены направления сортировки */
    _cycle(btn) {
        const dir = this._nextDir(this._readDir(btn));
        this._applyDir(btn, dir);
        this._applyAria(btn, dir);
        this._syncValue(btn, dir);
        // уведомляем владельца
        Promise.resolve(this._ownerAdapter.apply()).catch(() => { });
    }
    /** Синхронизация значения:
      * 1) если у самого маркера есть data-key, начинающийся с _tsc_ → пишем в его data-value
      * 2) иначе ищем hidden перед ним (или рядом) и обновляем value
      */
    _syncValue(btn, dir) {
        // 1) новый формат: data-key на самом маркере
        const dk = btn.getAttribute("data-key");
        if (dk && dk.startsWith("_tsc_")) {
            btn.setAttribute("data-value", dir || "");
            // если нужны слушатели:
            btn.dispatchEvent(new Event("change", { bubbles: true }));
            return;
        }
        // TODO: После перехода на новый ImSys отказаться на беке от использования этого сценария (см. TableElement)
        // 2) старый формат: hidden перед маркером
        let input = btn.previousElementSibling;
        if (!(input instanceof HTMLInputElement)) {
            input = btn.parentElement?.querySelector('input[type="hidden"][data-key^="_tsc_"]') ?? null;
        }
        if (input) {
            input.value = dir || "";
            input.dispatchEvent(new Event("change", { bubbles: true }));
        }
    }
    /** Читает текущее направление сортировки из классов */
    _readDir(btn) {
        if (btn.classList.contains('down'))
            return 'down';
        if (btn.classList.contains('up'))
            return 'up';
        return '';
    }
    /** Определяет следующее направление */
    _nextDir(cur) {
        switch (cur) {
            case '': return 'down';
            case 'down': return 'up';
            case 'up': return '';
        }
    }
    /** Применяет CSS-класс для нового направления */
    _applyDir(btn, dir) {
        btn.classList.remove('none', 'down', 'up');
        btn.classList.add(dir || 'none');
    }
    /** Устанавливает ARIA-атрибуты на кнопку и th */
    _applyAria(btn, dir) {
        btn.setAttribute('aria-pressed', dir ? 'true' : 'false');
        const th = btn.closest('th, [role="columnheader"]');
        if (th) {
            th.setAttribute('aria-sort', dir === '' ? 'none' : (dir === 'down' ? 'descending' : 'ascending'));
        }
    }
    /** Первичная гидрация ARIA на основе классов в DOM */
    _hydrateFromDom() {
        this.element.querySelectorAll(this._toggleSelector)
            .forEach(btn => {
            const dir = this._readDir(btn);
            this._applyAria(btn, dir);
        });
    }
    /** Отписка при уничтожении */
    _onDestroy() {
        this.element?.removeEventListener('click', this._onClick);
    }
}
/** Имя виджета */
SortWidget._alias = "Sort";

export { SortWidget };
